import { Formik, FormikProps } from 'formik';
import { InputSearchFormikDebounce } from '../Common';
import { useTranslation } from '../../hooks/useTranslation';

interface SearchFormProps {
    action: (value: string) => void;
    initialSearchValue?: string;
    regexPattern?: RegExp;
    fullWidth?: boolean;
}

interface ISearchForm {
    searchValue: string;
}

const SearchForm = ({ action, initialSearchValue, regexPattern, fullWidth }: SearchFormProps) => {
    const { t } = useTranslation('common');
    const initialValues: ISearchForm = { searchValue: initialSearchValue ?? '' };

    const onSubmit = (values: ISearchForm) => action(values.searchValue);

    const onClose = (context: FormikProps<ISearchForm>) => {
        context.setFieldValue('searchValue', '');
        action('');
    };

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {context => (
                <form onSubmit={context.handleSubmit} className={fullWidth ? 'width-100' : 'calendar-search__form'}>
                    <InputSearchFormikDebounce
                        id="searchValue"
                        placeholder={`${t('search')}...`}
                        className="calendar-search__input"
                        context={context}
                        isCloseButtonVisible={context.values.searchValue !== ''}
                        closeButtonOnClick={() => onClose(context)}
                        searchButtonOnClick={() => onSubmit(context.values)}
                        onChange={event => {
                            const newValue = event.target.value;
                            context.setFieldValue('searchValue', newValue);
                            onSubmit({ searchValue: newValue });
                        }}
                        regexPattern={regexPattern}
                    />
                </form>
            )}
        </Formik>
    );
};

export default SearchForm;
